enum JobWorkerOfferContactDeclinedReason {
    Undefined = -1,
    ChangedMind = 1,
    BudgetIssue = 2,
    FoundAlternativeWorker = 3,
    PositionNoLongerRequired = 4,
}

export default JobWorkerOfferContactDeclinedReason;